// The colorblind-safe semantic pair (sc-5843, reaffirmed sc-6057): HEXA
// charts encode the digest-driven vs ad-hoc distinction as BLUE vs ORANGE —
// never green vs red (the audience includes red-green colorblind readers;
// this is a hard product constraint, not a style preference). Every chart
// drawing this distinction imports from here so a palette change has one
// edit point: order heatmap cells, drawdown-chart order events, and the
// roll-up chart's HVA / non-HVA markers all carry the same two meanings.
export const CVD_BLUE = '#2e7bb5'; // digest-driven: by-deadline orders, HVA conversions
export const CVD_ORANGE = '#e69f00'; // ad-hoc/late: unprompted orders, non-HVA

// Mid tints of the pair for area fills (the combined table's diagonal day
// cells — sc-6127; historically the order heatmap's mid scale step): lighter
// than the mark anchors so cell text stays readable. Change together with
// the pair — they carry the same two meanings.
export const CVD_BLUE_TINT = '#7db8e0';
export const CVD_ORANGE_TINT = '#f3c46a';
export const CVD_NEUTRAL_TINT = '#d6d6d3'; // ignored / no signal

// Text-weight anchors of the pair (sc-6441): the Edge Review batch table's
// New max number reads blue above the max now and orange below it. The mark
// anchors above are too light for small text on white; these keep the same
// two hues at text contrast.
export const CVD_BLUE_TEXT = '#1559b0';
export const CVD_ORANGE_TEXT = '#b05000';
